import { render, staticRenderFns } from "./SkuInsight.vue?vue&type=template&id=4dcd3a12&scoped=true&"
import script from "./SkuInsight.vue?vue&type=script&lang=js&"
export * from "./SkuInsight.vue?vue&type=script&lang=js&"
import style0 from "./SkuInsight.vue?vue&type=style&index=0&id=4dcd3a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd3a12",
  null
  
)

export default component.exports